<template>
  <div class="login-container" v-loading="loading">
    <div class="login-header">
      <h1>远腾经销系统</h1>
      <el-divider></el-divider>
      <div class="login-form">
        <el-form ref="form" :model="form" label-width="10px">
          <el-form-item>
            <el-input
              v-model="form.username"
              placeholder="请输入用户名"
              :readonly="readonly"
              @focus="onFocus"><i class="el-icon-user" slot="prefix"></i></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.password"
                      placeholder="请输入密码"
                      show-password>
              <i class="el-icon-lock" slot="prefix" style=""></i>
            </el-input>
          </el-form-item>

          <el-form-item style="margin-top: 40px">
            <el-button size="medium" type="primary" @click="onSubmit">登录</el-button>
            <el-button size="medium" type="primary" @click="onBack">返回</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </div>
</template>

<script>
import global from './global/common'
  export default {
    name: 'Login',
    data() {
      return {
        form: {
          username: '',
          password: ''
        },
        newForm: {
          username: '',
          token: '',
          role: ''
        },
        readonly: true,
        loading: false
      }
    },
    methods: {
      onSubmit() {
        if (!this.form.username || !this.form.password) {
          this.$message.error("用户名和密码不能为空！！！");
        } else {
          this.loading = true;
          this.$http.post("https://yuanteng.tech:8081/user/login", this.form).then(res => {
            if (res.data !== "" && res.data !== null) {
              global.global_username = res.data.username;
              this.newForm.username = window.btoa(window.encodeURIComponent(res.data.username));
              this.newForm.token = res.data.token;
              this.newForm.role =  window.btoa(window.encodeURIComponent(res.data.role));
              localStorage.setItem("access-admin", JSON.stringify(this.newForm));
              this.$message({
                message: '恭喜你，登录成功...',
                type: 'success'
              });
              this.$router.push({
                name: 'home',
              });
            } else {
              this.$message.error('用户名或密码错误！！！');
            }
          }, (err) => {
            // console.log(err)
            this.$message.error(err.message)
          }).finally(() => {
            this.loading = false;
          })
        }

      },
      onBack() {
        this.$router.push('/yt');
      },
      onFocus() {
        this.readonly = false;
      }
    },
    created() {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-container {
    text-align: center;
    width: 100%;
    min-height: calc(100vh - 65px);
  }

  .login-header {
    width: 40%;
    margin: auto;
    margin-top: 60px;
  }

  .login-form {
    width: 40%;
    margin: auto;
  }

  h1 {
    letter-spacing: 10px;
  }

  @media screen and (max-width: 768px) {
    .login-header {
      width: 70%;
    }

    .login-form {
      width: 80%;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1280px) {
    .login-header {
      width: 60%;
    }

    .login-form {
      width: 60%;
    }
  }

  @media screen and (min-width: 1280px) {
    .login-header {
      width: 50%;
    }

    .login-form {
      width: 40%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue